import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import ProjectProd from "../components/Project/ProjectProd";
import Footer from "../components/Footer/Footer";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const ProjectPage = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("Projects");
      setText2("Some projects developed in recent years");
    } else if (lang === "it") {
      setText("Progetti");
      setText2("Alcuni progetti sviluppati negli ultimi anni");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - Projects</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <ProjectProd />
        <Footer />
      </motion.main>
    </>
  );
};

export default ProjectPage;
